<template>
  <div v-if="!job.length && !this.loader" class="job column">
    <div class="title row-g column-s column-m">
      <div class="title grid-12 row">
        JOB
        <b>&nbsp; {{ job.id_job || job.id }}</b>
      </div>
    </div>
    <div class="info row label align-center wrap">
      <div class="grid-6-s grid-4-m grid-2-g col">
        <label>Agendado para</label>
        <strong>{{ new Date(job.dh_agendamento_cliente).toLocaleString() }}</strong>
      </div>
      <div class="grid-6-s grid-8-g">
        <label>Atendimento</label>
        <br />
        <strong>{{ job.forma_atendimento }}</strong>
      </div>

      <div
        v-if="job.forma_atendimento != 'remoto'"
        class="openmap row justify-end-g grid-12-s grid-6-m grid-2-g"
      >
        <Button layout="white-m" @click="openMap">
          <img src="../assets/img/google.svg" alt /> &nbsp; Ver região de atendimento
        </Button>
      </div>
    </div>
    <div class="data column label">
      <div class="row-g column">
        <div class="grid-5-g grid-12-m grid-12-s">
          <label>Problema informado pelo cliente</label>
          <div class="problema" v-html="job.problema.replace(/\n/g, '<br />')"></div>
        </div>
        <div class="grid-7-g js column infoJob">
          <div class="row wrap">
            <div class="col grid-3 grid-6-s margin-top-s">
              <label>Tipo</label>
              <strong>{{ job.tipo }}</strong>
            </div>
            <div class="col grid-6-s grid-3 margin-top-s">
              <label>Duração</label>
              <strong>{{ job.duracao_atendimento }}</strong>
            </div>
            <div class="col grid-6-s grid-3 margin-top-s">
              <label>Folga</label>
              <strong>{{ job.duracao_folga }}</strong>
            </div>
            <div class="grid-6-s grid-3 margin-top-s col">
              <label>Atendimentos</label>
              <strong>{{ job.duracao_alocacao }}</strong>
            </div>
          </div>
          <div class="row row-2 wrap">
            <div class="grid-6-s grid-3 margin-top-s col">
              <label>Valor do job</label>
              <strong>{{ job.valor_job | money }}</strong>
            </div>
            <div class="grid-6-s grid-2 margin-top-s col">
              <label>Valor da hora extra</label>
              <strong>{{ job.valor_hora_extra | money }}</strong>
            </div>
            <div class="grid-12-s grid-6 margin-top-s info-info">
              Em todos os jobs o valor do deslocamento já está incluído no valor ofertado
            </div>
          </div>
        </div>
      </div>
      <div class="column margin-top">
        <div class="sub">Requesitos para o Job</div>

        <template v-if="job.pendencia_obrigatoria">
          <div
            v-for="(p, i) of job.pendencia_obrigatoria.filter(
              (j) => j.pendencia_obrigatoria
            )"
            class="row column-s mandatory justify-space align-center"
            :key="'pendency-' + i"
          >
            <div class="margin-top-s grid-4">{{ p.nome || p.nome_curso }}</div>
            <div
              class="red margin-top-s grid-4"
              v-if="p.curso_mandatorio || p.obrigatoria"
            >
              Obrigatório
            </div>
            <div class="row justify-end margin-top-s grid-4">
              <router-link to="/supporter/pendencias">
                <Button layout="red-go">Pendências</Button>
              </router-link>
            </div>
          </div>
        </template>
        <template v-if="job.pendencia_nao_obrigatoria">
          <div
            v-for="(p, i) of job.pendencia_nao_obrigatoria.filter(
              (j) => j.pendencia_nao_obrigatoria
            )"
            class="row column-s not-mandatory justify-space align-center"
            :key="'pendencyn-' + i"
          >
            <div class="margin-top-s grid-4">{{ p.nome || p.nome_curso }}</div>
            <div
              class="red margin-top-s grid-4"
              v-if="p.curso_mandatorio || p.obrigatoria"
            >
              Obrigatório
            </div>
            <div class="row justify-end margin-top-s grid-4">
              <router-link to="/supporter/pendencias">
                <Button layout="green-dark-p">Pendências</Button>
              </router-link>
            </div>
          </div>
        </template>

        <template v-if="job.curso_obrigatorio">
          <div
            v-for="(p, i) of job.curso_obrigatorio.filter((j) => j.curso_obrigatorio)"
            class="row column-s mandatory justify-space align-center"
            :key="'curso-' + i"
          >
            <div class="margin-top-s grid-4">
              {{ p.codigo_curso + " - " || "" }}{{ p.nome || p.nome_curso }}
            </div>
            <div
              class="red margin-top-s grid-4"
              v-if="p.curso_mandatorio || p.obrigatoria"
            >
              Obrigatório
            </div>
            <div class="row justify-end margin-top-s grid-4">
              <a :href="p.url || p.url_curso">
                <Button layout="red-go">Fazer Curso</Button>
              </a>
            </div>
          </div>
        </template>

        <template v-if="job.curso_nao_obrigatorio">
          <div
            v-for="(p, i) of job.curso_nao_obrigatorio.filter(
              (j) => j.curso_nao_obrigatorio
            )"
            class="row column-s not-mandatory justify-space align-center"
            :key="'cursoo-' + i"
          >
            <div class="margin-top-s grid-4">
              {{ p.codigo_curso + " - " || "" }}{{ p.nome || p.nome_curso }}
            </div>
            <div
              class="red margin-top-s grid-4"
              v-if="p.curso_mandatorio || p.obrigatoria"
            >
              Obrigatório
            </div>
            <div class="row justify-end margin-top-s grid-4">
              <a :href="p.url || p.url_curso">
                <Button layout="green-dark-p">Fazer Curso</Button>
              </a>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="buttons-2 row column-s align-center">
      <div class="grid-4 grid-12-s hide-s">
        <Button layout="white-m-gray" @click="router.push('/supporter/candidaturas')">
          <i class="fa fa-arrow-left"></i> Jobs
        </Button>
      </div>
      <div class="grid-8 grid-11-s row column-s justify-end justify-around">
        <Button
          v-if="!job.posicao_fila"
          layout="green-go"
          @click="
            loaderButton = true;
            SET_CANDIDATE(job.token_divulgacao)
              .then((r) => {
                loaderButton = false;
              })
              .catch(() => (loaderButton = false));
          "
          :loader="loaderButton"
          >QUERO ME CANDIDATAR</Button
        >

        <Button
          v-if="job.posicao_fila && job.status != 'desistiu'"
          layout="red-s"
          class="justify-center row"
          @click="
            loaderButton = true;
            CANCEL_CANDIDATE(job.id)
              .then(() => {
                router.push('/supporter/candidaturas');
                loaderButton = false;
              })
              .catch(() => (loaderButton = false));
          "
          >CANCELAR</Button
        >
      </div>
    </div>
    <Modal :modal="modal">
      <gmap-map
        class="region"
        :center="{ lat: job.latitude, lng: job.longitude }"
        :zoom="14"
      >
        <gmap-circle
          :options="{
            strokeWeight: '0',
            fillColor: '#31A6F5',
            fillOpacity: '0.35',
          }"
          :center="{ lat: job.latitude + 0.001, lng: job.longitude - 0.001 }"
          :radius="1000"
        ></gmap-circle>
      </gmap-map>
    </Modal>
  </div>
  <div v-else class="job-loader column align-center justify-center">
    <Loader />
  </div>
</template>

<script>
import Vue from "vue";
import Loader from "@/components/Loader";
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/Button";
import Modal from "@/components/Modal";
import Router from "@/router";
import * as VueGoogleMaps from "vue2-google-maps";
import { gmapApi } from "vue2-google-maps";

Vue.use(VueGoogleMaps, { load: { key: "AIzaSyBb14nrVdCZh_uBI-wGkjjmB0ypHS4YInY"}});

export default {
  name: "job",
  components: { Button, Loader, Modal },
  data() {
    return {
      loader: true,
      loaderButton: false,
      job: {},
      modal: {},
      router: Router,
      path: { lat: 0, lng: 0 },
    };
  },
  methods: {
    ...mapActions("jobs", ["LOAD_APPLY"]),
    ...mapGetters("job", ["GET_JOB"]),
    ...mapActions("job", ["LOAD_JOB_CANDIDATE", "SET_CANDIDATE", "CANCEL_CANDIDATE"]),
    async getJob() {
      if (this.$route.params.token) {
        this.LOAD_JOB_CANDIDATE(this.$route.params.token).then(() => {
          this.job = this.GET_JOB();
          this.loader = false;
        });
      } else {
        this.LOAD_APPLY().then((jobs) => {
          this.job = jobs.filter((job) => job.id_job == this.$route.params.id)[0];
          this.loader = false;
        });
      }
    },
    openMap() {
      this.modal = {
        id: this.id || this.$route.params.id,
        show: true,
        title: "Região de Atendimento",
        description: `${this.job.cidade}/${this.job.estado}`,
        layout: false,
        map: true,
      };
    },
  },
  computed: {google: gmapApi},
  mounted() {this.getJob()}
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.job {
  padding: 32px 35px;
  box-shadow: $shadow;
  background: $white;
  border-radius: 23px;
  label{
    @include label;
    text-transform: capitalize;
  }
  .buttons-2 {
    padding-top: 35px;
    @media (max-width: $small) {
      margin-top: 27px;
      margin-bottom: 10px;
      button {
        margin-bottom: 20px;
      }
    }
  }
  .problema{
    padding: 12px 5px;
    font-weight: bold;
  }
  .margin-top {
    margin-top: 35px;
    &-s {
      @media (max-width: $small) {
        margin-top: 25px;
      }
    }
  }
  .sub {
    margin-bottom: 25px;
  }
  .mandatory,
  .not-mandatory {
    background: $red-6;
    padding: 10px 25px;
    border-radius: 5px;
    margin-top: 10px;
    button {
      width: 120px;
    }
  }

  .not-mandatory {
    background: $green-8;
  }
  .red {
    color: $red-5;
  }
  &-loader {
    margin-top: 20%;
  }
  .title {
    font-size: 26px;
    font-weight: 400;
    b {
      color: $supporter-1;
    }
  }

  .infoJob {
    margin-top: 25px;
    @media (min-width: $large) {
      margin-left: 50px;
    }
  }
  .info {
    margin-top: 25px;
    padding-bottom: 34px;
    border-bottom: 1px solid $white-1;
  }
  .status {
    color: $white-7;
    font-size: 12px;
    list-style: none;

    li {
      margin-left: 40px;
      @media (max-width: $medium) {
        margin-left: 10px;
      }
    }
    .active {
      color: $green-9;
      border-bottom: 2px solid $green-9;
      height: 30px;
      font-weight: bold;
    }
  }
  .label {
    color: $gray-6;
    font-size: 15px;
    font-weight: 300;
  }
  .data {
    padding-top: 45px;
    padding-bottom: 46px;
    border-bottom: 1px solid $white-1;
    label {
      margin-bottom: 8px;
    }
    .grid-2-g {
      @media (max-width: $small) {
        margin-bottom: 30px;
      }
    }
    .ps {
      color: $gray-6;
      background: $white-8;
      padding: 8px 14px;
      border-radius: 5px;
      margin-left: 30px;
    }
    .row-2 {
      margin-top: 32px;
    }
  }
  .info-info {
    color: $gray-6;
    background: $white-8;
    border-radius: 5px;
    padding: 12px;
  }
  .openmap {
    @media (max-width: $medium) and (min-width: $small) {
      margin-top: 38px;
    }
    @media (max-width: $small) {
      margin-top: 38px;
      justify-content: center;
      button {
        width: 100%;
      }
    }

    @media (min-width: $small) and (max-width: $large) {
      margin-top: 25px;
      justify-content: flex-end;
    }
  }
  .button-green-go,
  .button-blue-go,
  .button-red-go {
    margin-left: 10.5px;
  }
  .button-red-s {
    line-height: 24px;
  }

  .vue-map-container {
    width: 100%;
    height: 330px;
  }
  .region {
    @media (min-width: $small) {
      /* width: 50%; */
      width: 600px;
    }
  }
}
</style>
